import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const ToggleContainer = styled.div`
  display: inline-flex;
  background: ${(props) =>
    props.theme?.name === 'dark'
      ? 'rgba(255, 255, 255, 0.05)'
      : 'rgba(0, 0, 0, 0.05)'};
  padding: 6px;
  border-radius: 12px;
  border: 1px solid
    ${(props) =>
      props.theme?.name === 'dark'
        ? 'rgba(255, 255, 255, 0.1)'
        : 'rgba(0, 0, 0, 0.1)'};

  @media (max-width: 768px) {
    display: flex;
    width: 100%;
  }
`;

const ToggleButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: all 0.2s;

  ${(props) =>
    props.active
      ? `
    background: #FA4616;
    color: white;
    box-shadow: 0 0 20px rgba(250, 70, 22, 0.3);
  `
      : `
    background: transparent;
    color: ${props.theme?.name === 'dark' ? '#94A3B8' : '#64748B'};

    &:hover {
      color: ${props.theme?.name === 'dark' ? '#ffffff' : '#0F172A'};
    }
  `}

  @media (max-width: 768px) {
    flex: 1;
    justify-content: center;
  }
`;

const SparklesIcon = () => (
  <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
    <path
      fillRule="evenodd"
      d="M9 4.5a.75.75 0 01.721.544l.813 2.846a3.75 3.75 0 002.576 2.576l2.846.813a.75.75 0 010 1.442l-2.846.813a3.75 3.75 0 00-2.576 2.576l-.813 2.846a.75.75 0 01-1.442 0l-.813-2.846a3.75 3.75 0 00-2.576-2.576l-2.846-.813a.75.75 0 010-1.442l2.846-.813A3.75 3.75 0 007.466 7.89l.813-2.846A.75.75 0 019 4.5zM18 1.5a.75.75 0 01.728.568l.258 1.036c.236.94.97 1.674 1.91 1.91l1.036.258a.75.75 0 010 1.456l-1.036.258c-.94.236-1.674.97-1.91 1.91l-.258 1.036a.75.75 0 01-1.456 0l-.258-1.036a2.625 2.625 0 00-1.91-1.91l-1.036-.258a.75.75 0 010-1.456l1.036-.258a2.625 2.625 0 001.91-1.91l.258-1.036A.75.75 0 0118 1.5z"
      clipRule="evenodd"
    />
  </svg>
);

const BookOpenIcon = () => (
  <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
    <path d="M11.25 4.533A9.707 9.707 0 006 3a9.735 9.735 0 00-3.25.555.75.75 0 00-.5.707v14.25a.75.75 0 001 .707A8.237 8.237 0 016 18.75c1.995 0 3.823.707 5.25 1.886V4.533zM12.75 20.636A8.214 8.214 0 0118 18.75c.966 0 1.89.166 2.75.47a.75.75 0 001-.708V4.262a.75.75 0 00-.5-.707A9.735 9.735 0 0018 3a9.707 9.707 0 00-5.25 1.533v16.103z" />
  </svg>
);

const ModeToggle = ({ mode, setMode }) => {
  return (
    <ToggleContainer>
      <ToggleButton
        active={mode === 'discover'}
        onClick={() => setMode('discover')}
      >
        <SparklesIcon />
        <span>Ideas & Tips</span>
      </ToggleButton>
      <ToggleButton active={mode === 'howto'} onClick={() => setMode('howto')}>
        <BookOpenIcon />
        <span>How To Do It</span>
      </ToggleButton>
    </ToggleContainer>
  );
};

ModeToggle.propTypes = {
  mode: PropTypes.oneOf(['discover', 'howto']).isRequired,
  setMode: PropTypes.func.isRequired,
};

export default ModeToggle;
